// tslint:disable:max-classes-per-file
export class CoralDeserializationTypeError extends TypeError {
    constructor(receivedType = 'undefined', expectedType = 'undefined') {
        const message = `[CoralDeserializationTypeError] Cannot deserialize received type
    "${receivedType}" to type "${expectedType}"`;
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
export class CoralSerializationTypeError extends TypeError {
    constructor(receivedType = 'undefined', expectedType = 'undefined') {
        const message = `[CoralSerializationTypeError] Cannot serialize received type
    "${receivedType}" to type "${expectedType}"`;
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
